"use strict";

exports.__esModule = true;
exports.verifyConsentPolicy = verifyConsentPolicy;
exports.verifyConsentPolicyCategoryIfExists = verifyConsentPolicyCategoryIfExists;

var _constants = require("./utils/constants");

/* global consentPolicyManager, Wix */
var CONSENT_POLICY_CATEGORIES = ['essential', 'functional', 'analytics', 'advertising'];

function verifyConsentPolicy(category) {
  var policy = getConsentPolicy();

  if (typeof policy !== 'undefined' && !policy[category]) {
    throw _constants.COOKIE_CONSENT_DISALLOWED;
  }
}

function verifyConsentPolicyCategoryIfExists(category) {
  if (!category) return;

  if (CONSENT_POLICY_CATEGORIES.indexOf(category) === -1) {
    var categories = CONSENT_POLICY_CATEGORIES.map(function (v) {
      return "'" + v + "'";
    }).join(', ');
    throw new Error("category must be one of " + categories);
  }
}

function getConsentPolicy() {
  var _ref = resolveByNativeAPI() || resolveByJsSDK() || none(),
      policy = _ref.policy;

  return policy;
}

function resolveByNativeAPI() {
  return typeof consentPolicyManager === 'object' && consentPolicyManager.getCurrentConsentPolicy && consentPolicyManager.getCurrentConsentPolicy();
}

function resolveByJsSDK() {
  return typeof Wix === 'object' && Wix.Utils && Wix.Utils.getCurrentConsentPolicy && Wix.Utils.getCurrentConsentPolicy();
}

function none() {
  return {};
}